<template>
  <div class="sort-indicator" :class="{active, direction}">
    <md-icon :class="{active: active && direction === 'ASC'}">arrow_drop_up</md-icon>
    <md-icon :class="{active: active && direction === 'DESC'}">arrow_drop_down</md-icon>
  </div>
</template>

<script>
export default {
  name: 'sort-indicator',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: 'ASC',
      validate: value => ['ASC', 'DESC'].includes(value)
    }
  }
}
</script>

<style scoped>
.sort-indicator {
  display: flex;
  flex-direction: column;
}

.sort-indicator.active .md-icon:not(.active) {
  opacity: 0.5;
}

.sort-indicator.active .md-icon.active {
  color: #3f83c5;
}

.md-icon {
  height: 8px;
}
</style>